import axios from 'axios';

const API_URL = '/api/risk-cate';
const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getRiskCates = async (token, comCode) => {
  const params = comCode ? { M_ComCode: comCode } : {};
  const res = await axios.get(API_URL, { ...h(token), params });
  return res.data;
};

export const getRiskCateById = async (id, token, comCode) => {
  const params = comCode ? { M_ComCode: comCode } : {};
  const res = await axios.get(`${API_URL}/${id}`, { ...h(token), params });
  return res.data;
};

export const createRiskCate = async (data, token, comCode) => {
  const body = comCode ? { ...data, M_ComCode: comCode } : data;
  const res = await axios.post(API_URL, body, h(token));
  return res.data;
};

export const updateRiskCate = async (id, data, token, comCode) => {
  const body = comCode ? { ...data, M_ComCode: comCode } : data;
  const res = await axios.put(`${API_URL}/${id}`, body, h(token));
  return res.data;
};

export const deleteRiskCate = async (id, token, comCode) => {
  const params = comCode ? { M_ComCode: comCode } : {};
  const res = await axios.delete(`${API_URL}/${id}`, { ...h(token), params });
  return res.data;
};
